class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((type, event) => {
      this.onSubmitHandler(event, type);
    }, 500);

    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this, 'facets'));
    // price range filter
    if (this.querySelector('form .range__field'))
      this.querySelector('form .range__field').addEventListener('priceRange', this.debouncedOnSubmit.bind(this, 'facets'));
    // collection names filter
    if (this.querySelectorAll('form .collection__title'))
      this.querySelectorAll('form .collection__title').forEach(element => {
        element.addEventListener('click', this.debouncedOnSubmit.bind(this, 'collection'))
      });
    if (this.querySelectorAll('form .collection__title'))
      this.querySelectorAll('form .collection__title').forEach(element => {
        element.addEventListener('click', function () {
          let collectionId = element.getAttribute('data-collection-id');
          let collectionHandle = element.getAttribute('data-collection-handle');
          // handle nosto collection change
          window.collection['id'] = collectionId;
          window.collection['handle'] = collectionHandle;
          // remove active collection
          document.querySelectorAll('form .collection__title').forEach(element => {
            if (element.classList.contains('is-active-collection')) {
              element.classList.remove('is-active-collection');
            }
          });
          // update products based on collection name
          if (!element.classList.contains('is-active-collection')) {
            element.classList.add('is-active-collection');
            if (document.querySelectorAll(`form .collection__title[data-url="${element.dataset.url}"]`)) {
              document.querySelectorAll(`form .collection__title[data-url="${element.dataset.url}"]`).forEach(item => {
                if (!item.classList.contains('is-active-collection')) {
                  item.classList.add('is-active-collection');
                }
              })
            }
          }
          window.scrollTo(0, 0);
        })
      });

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
    // on refresh setup price range values
    let urlString = window.location.href,
      url = new URL(urlString),
      maxPrice = url.searchParams.get("filter.v.price.lte"),
      minPrice = url.searchParams.get("filter.v.price.gte");
    // FacetFiltersForm.setUpPriceRange(minPrice, maxPrice);
    // FacetFiltersForm.renderAllowedCollections(document);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static setUpPriceRange(minPrice, maxPrice) {
    let rangeSliderElement = document.querySelector('#range-slider-example'),
      rangeSliderMobile = document.querySelector('#range-slider-example-mobile'),
      desktopRangeParent = document.getElementById('FacetFiltersForm'),
      mobileRangeParent = document.getElementById('FacetFiltersFormMobile');

    // FacetFiltersForm.rangeSliderElementCreate(rangeSliderElement, minPrice, maxPrice, desktopRangeParent);
    // FacetFiltersForm.rangeSliderElementCreate(rangeSliderMobile, minPrice, maxPrice, mobileRangeParent);
  }

  static rangeSliderElementCreate(selector, minPrice, maxPrice, parent) {
    let minValue = minPrice ? minPrice : window.priceRanges.min,
      maxValue = maxPrice ? maxPrice : window.priceRanges.max,
      minValueText = parent.querySelector('.range-min-value span'),
      maxValueText = parent.querySelector('.range-max-value span');
    if (minValueText) minValueText.innerHTML = minValue;
    if (maxValueText) maxValueText.innerHTML = maxValue;

    if (selector) rangeSlider(selector, {
      // min value
      min: window.priceRanges.min,
      // max value
      max: window.priceRanges.max,

      // step size
      step: 5,
      // initial values
      value: [minValue, maxValue],
      // disable the range slider element
      disabled: false,
      // disable the range slider
      rangeSlideDisabled: false,
      // disable left/right (top/bottom) thumbs
      thumbsDisabled: [false, false],
      // or 'vertical'
      orientation: 'horizontal',
      // callback function
      onInput: function (valueSet) {
        let numberS = parent.querySelectorAll('.range__field'),
          minValueText = parent.querySelector('.range-min-value span'),
          maxValueText = parent.querySelector('.range-max-value span');

        numberS[0].value = valueSet[0];
        numberS[1].value = valueSet[1];
        minValueText.innerHTML = valueSet[0];
        maxValueText.innerHTML = valueSet[1];
        numberS[0].dispatchEvent(new Event('priceRange'))
        numberS[1].dispatchEvent(new Event('priceRange'))
      },
    })
  }

  static renderPage(searchParams, event, updateURLHash = true,
    lowPrice = window.priceRanges.min, highPrice = window.priceRanges.max, type = "facets") {
    // let facetsFooter = document.querySelector('.mobile-facets__footer'),
    //   activeFacetsWrapper = document.querySelector('#active-facets-container');
    // // if(type === 'collection'){
    // //   searchParams = '';
    // // }
    // if (searchParams.includes('filter')) {
    //   facetsFooter.style.display = 'flex';
    //   if (!activeFacetsWrapper.classList.contains('active-facets--displayed')) {
    //     activeFacetsWrapper.classList.add('active-facets--displayed');
    //   }
    // } else {
    //   facetsFooter.style.display = 'none';
    //   if (activeFacetsWrapper.classList.contains('active-facets--displayed')) {
    //     activeFacetsWrapper.classList.remove('active-facets--displayed');
    //   } 
    // }

    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      if (section.section) {
        let url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
        if (type === 'collection') {
          url = `${event.target.dataset.url}?section_id=${section.section}&${searchParams}`;
        }
        const filterDataUrl = element => element.url === url;

        FacetFiltersForm.filterData.some(filterDataUrl) ?
          FacetFiltersForm.renderSectionFromCache(filterDataUrl, event, section.type, url) :
          FacetFiltersForm.renderSectionFromFetch(url, event, section.type);
      }
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams, type, (type === 'collection' ? event.target.dataset.url : ''));
    // let priceRangeWrapper = document.querySelector('.price-range__wrapper');

    // if (!priceRangeWrapper.hasAttribute('open')) {
    //   setTimeout(() => {
    //     FacetFiltersForm.setUpPriceRange(lowPrice, highPrice);
    //     let facetForm = document.querySelector('facet-filters-form');
    //     let facetFormMobile = document.querySelector('facet-filters-form.facet-filters-form-mobile');
    //     if (facetForm.querySelector('form .range__field'))
    //       facetForm.querySelector('form .range__field').addEventListener('priceRange', facetForm.debouncedOnSubmit.bind(this, 'facets'));
    //     if (facetFormMobile.querySelector('form .range__field'))
    //       facetFormMobile.querySelector('form .range__field').addEventListener('priceRange', facetFormMobile.debouncedOnSubmit.bind(this, 'facets'));
    //   }, 1500);
    // }
  }

  static renderSectionFromFetch(url, event, type) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        if (type === 'product') {
          FacetFiltersForm.renderFilters(html, event);
          FacetFiltersForm.renderProductGridContainer(html);
          // FacetFiltersForm.renderProductCount(html);
          if (window.nostoLoading) handleNostoApiCall(0, false, url);
        } else if (type === 'slideshow') {
          FacetFiltersForm.renderProductGridSlideshow(html);
        } else if (type === 'faq-section') {
          FacetFiltersForm.renderProductGridFAQ(html);
        } else {
          FacetFiltersForm.renderProductGridBanner(html);
        }
      }).catch((e) => {
        console.error(e);
      });
  }

  static renderSectionFromCache(filterDataUrl, event, type, url) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    if (type === 'product') {
      FacetFiltersForm.renderFilters(html, event);
      FacetFiltersForm.renderProductGridContainer(html);
      // FacetFiltersForm.renderProductGridBanner(html);

      // FacetFiltersForm.renderProductCount(html);
      if (window.nostoLoading) handleNostoApiCall(0, false, url);
    } else if (type === 'slideshow') {
      FacetFiltersForm.renderProductGridSlideshow(html);
    } else if (type === 'faq-section') {
      FacetFiltersForm.renderProductGridFAQ(html);
    } else {
      FacetFiltersForm.renderProductGridBanner(html);
    }
  } 

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
    if (typeof loadProducts === "function") {
      loadProducts();
    }
    document.dispatchEvent(new CustomEvent('theme:loading:end'));
  }

  static renderProductGridSlideshow(html) {
    if (document.getElementById('slideshow'))
      document.getElementById('slideshow').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('slideshow').innerHTML;
  }

  static renderProductGridFAQ(html) {
    if (document.getElementById('faq-section'))
      document.getElementById('faq-section').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('faq-section').innerHTML;
  }
  static renderProductGridBanner(html) {
    if (document.getElementById('main-collection-banner'))
      document.getElementById('main-collection-banner').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('main-collection-banner').innerHTML;
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter');
    const facetsContainer = Array.from(document.querySelectorAll('#FacetFiltersForm .js-filter'));
    const facetsContainerDom = document.querySelectorAll('#FacetFiltersForm .js-filter');


    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }

    const countsToRender = Array.from(facetDetailsElements).filter(element => matchesIndex(element));

    if (facetDetailsElements.length < 1) {
      document.querySelector('#FacetFiltersForm').innerHTML = '';
    }
    // desktop filters
    let itemId = null;
    facetDetailsElements.forEach((element, index) => {
      if (countsToRender) {
        for (let i = 0; i < countsToRender.length; i++) {
          if (countsToRender[i].id == element.id) {
            itemId = element.id;
            break;
          }
        }
      }
      if (facetsContainer) {
        facetsContainer[index] = element;
        let lastIndex = facetDetailsElements.length;
        while (facetsContainer[lastIndex]) {
          facetsContainer[lastIndex].remove();
          lastIndex++;
        }
      }
    });
    facetsContainer.forEach((element, index) => {
      if (!facetsContainerDom[index]) {
        document.querySelector('#FacetFiltersForm').appendChild(element);
      } else {
        if (facetsContainerDom[index].id != itemId) {
          facetsContainerDom[index].replaceWith(element);
        }
      }
    })
    // mobile filtes
    const facetsContainerMobile = Array.from(document.querySelectorAll('#FacetsWrapperMobile .js-filter'));
    const facetsContainerDomMobile = document.querySelectorAll('#FacetsWrapperMobile .js-filter');
    const facetDetailsElementsMobile = parsedHTML.querySelectorAll('#FacetFiltersFormMobile .js-filter');
    const countsToRenderMobile = Array.from(facetDetailsElementsMobile).filter(element => matchesIndex(element));

    if (facetDetailsElementsMobile.length < 1) {
      document.querySelector('#FacetsWrapperMobile').innerHTML = '';
    }
    let mobileItemId = null;
    facetDetailsElementsMobile.forEach((element, index) => {
      if (countsToRenderMobile) {
        for (let i = 0; i < countsToRenderMobile.length; i++) {
          if (countsToRenderMobile[i].id == element.id) {
            mobileItemId = element.id;
            break;
          }
        }
      }
      facetsContainerMobile[index] = element;
      let lastIndex = facetDetailsElementsMobile.length;
      while (facetsContainerMobile[lastIndex]) {
        facetsContainerMobile[lastIndex].remove();
        lastIndex++;
      }

    });
    facetsContainerMobile.forEach((element, index) => {
      if (!facetsContainerDomMobile[index]) {
        document.querySelector('#FacetsWrapperMobile').appendChild(element);
      } else {
        if (facetsContainerDomMobile[index].id != mobileItemId) {
          facetsContainerDomMobile[index].replaceWith(element);
        }
      }
    })

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);
    // FacetFiltersForm.renderAllowedCollections(parsedHTML);
    // if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }
  static renderAllowedCollections(html) {
    let collectionFilters = document.querySelectorAll('.collection-filters__wrapper .collection__title[data-selected-collection]'),
      products = html.querySelectorAll('#product-grid .grid__item');

    if (FacetFiltersForm.searchParamsPrev.trim() != ''
      && FacetFiltersForm.searchParamsPrev.includes('&')) {
      if (collectionFilters) {
        collectionFilters.forEach((filter) => {
          let collectExist = false;
          for (let i = 0; i < products.length; i++) {
            if (products[i].dataset.collectionsUrls.includes(filter.dataset.url)) {
              collectExist = true;
              break;
            }
          }
          if (!collectExist) {
            if (!filter.classList.contains('is-disabled')) {
              filter.classList.add('is-disabled');
            }
          }

        });
      }
    } else {
      if (collectionFilters) {
        collectionFilters.forEach((filter) => {
          if (filter.classList.contains('is-disabled')) {
            filter.classList.remove('is-disabled');
          }
        });
      }
    }
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
  }

  static updateURLHash(searchParams, type = 'facets', collectionPath) {
    let url = window.location.pathname;
    if (type === 'collection') {
      url = collectionPath;
    }
    history.pushState({ searchParams }, '', `${url}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
        type: 'product'
      },
      {
        section: document.getElementById('slideshow') ? document.getElementById('slideshow').dataset.id : '',
        type: 'slideshow'
      },
      {
        section: document.getElementById('faq-section') ? document.getElementById('faq-section').dataset.id : '',
        type: 'faq-section'
      },
      {
        section: document.getElementById('main-collection-banner') ? document.getElementById('main-collection-banner').dataset.id : '',
        type: 'main-collection-banner'
      }
    ]
  }

  onSubmitHandler(event, type) {
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    // don't filter prices with the default price range.
    if (formData.get("filter.v.price.gte") == window.priceRanges.min
      && formData.get("filter.v.price.lte") == window.priceRanges.max) {
      formData.delete("filter.v.price.gte");
      formData.delete("filter.v.price.lte");
    }
    const searchParams = new URLSearchParams(formData).toString();
    FacetFiltersForm.renderPage(searchParams, event, true, formData.get("filter.v.price.gte"), formData.get("filter.v.price.lte"), type);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));

    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelector('a').addEventListener('click', (event) => {
      event.preventDefault();
      const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
      form.onActiveFilterClick(event);
    });
  }
}

customElements.define('facet-remove', FacetRemove);
